$(function () {
    svg4everybody();
});